import { render } from "./ProductPartsNames.vue?vue&type=template&id=4a5d8d08"
import script from "./ProductPartsNames.vue?vue&type=script&lang=js"
export * from "./ProductPartsNames.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__